function leerLongitudAsn1(bytes, offset) {
    let len = bytes[offset++];
    if (len & 0x80) {
        const numBytes = len & 0x7f;
        len = 0;
        for (let i = 0; i < numBytes; i++) {
            len = (len << 8) | bytes[offset++];
        }
    }
    return { length: len, offset };
}

function parsearTiempoAsn1(bytes, offset) {
    const tag = bytes[offset];
    if (tag !== 0x17 && tag !== 0x18) {
        return null;
    }
    const { length, offset: startValue } = leerLongitudAsn1(bytes, offset + 1);
    const str = String.fromCharCode(...bytes.slice(startValue, startValue + length));
    let date = null;

    if (tag === 0x17) {
        const yy = parseInt(str.slice(0, 2), 10);
        const year = yy >= 50 ? 1900 + yy : 2000 + yy;
        date = new Date(Date.UTC(
            year,
            parseInt(str.slice(2, 4), 10) - 1,
            parseInt(str.slice(4, 6), 10),
            parseInt(str.slice(6, 8), 10) || 0,
            parseInt(str.slice(8, 10), 10) || 0,
            parseInt(str.slice(10, 12), 10) || 0
        ));
    } else {
        date = new Date(Date.UTC(
            parseInt(str.slice(0, 4), 10),
            parseInt(str.slice(4, 6), 10) - 1,
            parseInt(str.slice(6, 8), 10),
            parseInt(str.slice(8, 10), 10) || 0,
            parseInt(str.slice(10, 12), 10) || 0,
            parseInt(str.slice(12, 14), 10) || 0
        ));
    }

    if (!date || Number.isNaN(date.getTime())) {
        return null;
    }
    return date;
}

function extraerFechaVencimientoX509(bytes) {
    const fechas = [];
    for (let i = 0; i < bytes.length - 13; i++) {
        if (bytes[i] !== 0x17 && bytes[i] !== 0x18) {
            continue;
        }
        const fecha = parsearTiempoAsn1(bytes, i);
        if (fecha && fecha.getFullYear() >= 2000 && fecha.getFullYear() <= 2100) {
            fechas.push(fecha);
        }
    }
    if (fechas.length === 0) {
        return null;
    }
    return new Date(Math.max(...fechas.map((f) => f.getTime())));
}

function pemABinario(pem) {
    const base64 = pem
        .replace(/-----BEGIN CERTIFICATE-----/g, '')
        .replace(/-----END CERTIFICATE-----/g, '')
        .replace(/\s/g, '');
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

export async function leerVencimientoCertificadoCer(archivo) {
    const buffer = await archivo.arrayBuffer();
    const preview = new TextDecoder().decode(buffer.slice(0, 64));
    const bytes = preview.includes('BEGIN CERTIFICATE')
        ? pemABinario(new TextDecoder().decode(buffer))
        : new Uint8Array(buffer);
    return extraerFechaVencimientoX509(bytes);
}

export function calcularRecordatorioRenovacion(vencimiento) {
    const recordatorio = new Date(vencimiento);
    recordatorio.setMonth(recordatorio.getMonth() - 1);
    return recordatorio;
}
